'use strict';
const workerLogger = require('./workerLogger');
const {setElementoryArguments} = require('./elementoryArgumentsHandler');
const {fetchUserCode, fetchUserCodeAsync, startUserCode} = require('./userCodeHandler');


function wixCodeBootstrap(consoleInstance, sendCallback, {viewMode} = {}) { //eslint-disable-line no-unused-vars
  //TODO: wrap the console only in preview mode
  workerLogger.wrapConsole(consoleInstance, sendCallback);
}

function updateWixCodeData({elementoryArguments}) {
  if (elementoryArguments) {
    setElementoryArguments(elementoryArguments);
  }
}

module.exports = {
  fetchUserCode,
  fetchUserCodeAsync,
  startUserCode,
  wixCodeBootstrap,
  updateWixCodeData
};
